// extracted by mini-css-extract-plugin
export var location = "contact-module--location--2myfo";
export var locationMap = "contact-module--location-map--1Fg0u";
export var locationDetail = "contact-module--location-detail--1Afih";